export const BaseUrl = "https://api.mmabetclub.com";
// export const BaseUrl = "http://localhost:8000";
// export const BaseUrl = 'http://192.168.0.150:8000'
export const mainSiteUrl = "https://mmabetclub.com"
export const ImageUrl = "https://mma-prod-assets.s3.amazonaws.com/"; 


// Event year
export const EventYearIs = new Date().getFullYear();